// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import less from 'less'
import QRCode from "qrcodejs2";
import ElementUI from 'element-ui'
import axios from 'axios';
import * as echarts from 'echarts'
import bykApi from './common/bykApi.js'
import store from './store/index.js'
import 'element-ui/lib/theme-chalk/index.css'
import '../src/assets/css/reset.css'
import '../src/assets/css/global.css'




import 'xe-utils'
import VXETable from 'vxe-table'
import 'vxe-table/lib/style.css'


Vue.config.productionTip = false

Vue.use(less)
Vue.use(ElementUI)
Vue.use(VXETable)
Vue.prototype.bykApi = bykApi
Vue.prototype.axios = axios
Vue.prototype.QRCode = QRCode
Vue.prototype.$echarts = echarts

//eventBus
import eventBus from './assets/js/bus.js';
Vue.prototype.eventBus = eventBus;


//线上环境去掉console.log
if (process.env.NODE_ENV === 'production') {
  if (window) {
    window.console.log = function() {};
  }
}

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})




// WEBPACK FOOTER //
// ./src/main.js